import { Point } from "../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (points: Point[]) => {
  const lats = points.map((m) => m.lat);
  const lngs = points.map((m) => m.lng);
  return {
    lat: (Math.min(...lats) + Math.max(...lats)) / 2,
    lng: (Math.min(...lngs) + Math.max(...lngs)) / 2,
  };
};
